import { render, staticRenderFns } from "./ProfileChangeRequestList.vue?vue&type=template&id=153b37d6&scoped=true&"
import script from "./ProfileChangeRequestList.vue?vue&type=script&lang=js&"
export * from "./ProfileChangeRequestList.vue?vue&type=script&lang=js&"
import style0 from "./ProfileChangeRequestList.vue?vue&type=style&index=0&id=153b37d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153b37d6",
  null
  
)

export default component.exports